import * as React from 'react'
import styled from 'styled-components'

export type PropertyFieldWrapperProps = {
  styling?: 'editor' | 'dialog' | 'summary'
}

export const PropertyFieldWrapper = styled.section<PropertyFieldWrapperProps>`
  --height: ${(props) => (props.styling === 'editor' ? 24 : 32)}px;
  --font-size: 12px;
  padding: ${(props) => (props.styling === 'editor' ? '0 32px 0 0' : '0px')};
  height: var(--height);
  line-height: var(--height);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: var(--height);
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
`

export const PropertyFieldLabel = styled.label`
  box-sizing: border-box;
  grid-row-start: 1;
  grid-column-start: 1;
  z-index: 5;
  text-align: left;
  justify-self: start;
  font-size: var(--font-size);
  line-height: var(--height);
  font-weight: 400;
  text-transform: capitalize;
  color: #767676;
`

export const PropertyFieldInputWrapper = styled.div`
  box-sizing: border-box;
  grid-row-start: 1;
  /* grid-column-start: 1; */
  display: grid;
`

export const PropertyFieldInput = styled.textarea`
  width: 100%;
  overflow: hidden;
  resize: none;
  text-align: right;
  outline: none;
  border: none;
  margin: 0;
  box-sizing: border-box;
  max-height: 100%;
  font-size: var(--font-size);
  line-height: calc(var(--height) - 4px); /* var(--height);*/
  padding: 0;
  flex: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  margin: 2px 0 0 8px;
  padding-right: 4px;
  &:disabled, &[disabled="disabled"]  {
    color: inherit;
    background-color: transparent;
  }
`

export type PropertyFieldBaseProps = {
  label?: string
} & PropertyFieldWrapperProps

export const PropertyFieldBase: React.FC<PropertyFieldBaseProps> = ({
  label,
  styling,
  children,
  ...props
}) => (
  <PropertyFieldWrapper {...{ styling, ...props }}>
    {label && <PropertyFieldLabel>{label}</PropertyFieldLabel>}
    <PropertyFieldInputWrapper>{children}</PropertyFieldInputWrapper>
  </PropertyFieldWrapper>
)
